/**
 * RegionDefaults.js
 * Maps locale to default date/time format strings.
 * Used by UserSettingsResolver when no BE override is present.
 */

const REGION_DEFAULTS = {
    'nl': { chipDateTimeFormat: 'DD.MM.YYYY, HH:mm:ss', dateFormat: 'DD.MM.YYYY' },
    'de': { chipDateTimeFormat: 'DD.MM.YYYY, HH:mm:ss', dateFormat: 'DD.MM.YYYY' },
    'en-US': { chipDateTimeFormat: 'MM/DD/YYYY, hh:mm:ss A', dateFormat: 'MM/DD/YYYY' },
    'en-GB': { chipDateTimeFormat: 'DD/MM/YYYY, HH:mm:ss', dateFormat: 'DD/MM/YYYY' },
    'fr': { chipDateTimeFormat: 'DD/MM/YYYY, HH:mm:ss', dateFormat: 'DD/MM/YYYY' },
};

const FALLBACK = { chipDateTimeFormat: 'YYYY-MM-DD, HH:mm:ss', dateFormat: 'YYYY-MM-DD' };

/**
 * Returns region-based default settings for the current browser locale.
 * Tries full locale first (en-US), then language prefix (en), then fallback.
 * @returns {{ chipDateTimeFormat: string, dateFormat: string }}
 */
const getRegionDefaults = () => {
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const lang = locale.split('-')[0];
    return REGION_DEFAULTS[locale] ?? REGION_DEFAULTS[lang] ?? FALLBACK;
};

export default getRegionDefaults;
